document.addEventListener('DOMContentLoaded', (domE) => {
  const grids = document.querySelectorAll('.paragraph--type--grid');

  // Now we actually adjust the height
  const loadHeightAdjustment = () => {
    let css = '';
    for (let i = 0; i < grids.length; i++) {
      let largestHeight = 0;
      const iconTextParagraphs = grids[i].querySelectorAll('.paragraph--type--icon-text-card .field-name-field-icon-graphic');

      for (let j = 0; j < iconTextParagraphs.length; j++) {
        let myHeight = iconTextParagraphs[j].getBoundingClientRect().height;        
        largestHeight = (myHeight > largestHeight) ? myHeight : largestHeight;
      }

      
      if (largestHeight > 0) {
        css += '#' + grids[i].getAttribute('id') + ' .field-name-field-icon-graphic {';
        css += ' height: ' + Math.ceil(largestHeight) + 'px; }' + "\n";
      }
    }
  
    if (css.length > 0) {
      const thisStyle = document.createElement('style');
      thisStyle.classList.add('grid-image-text-cards-icons-height');
      thisStyle.textContent = css;
      document.querySelector('body').appendChild(thisStyle);
    }
  };

  // First lets verify we get consistent heights for each of the sets; ie images are loaded
  // let hasPassed = false;
  (function(loadHeightAdjustment) {
    let heights = [];
    const checks = setInterval(function(){
      for (let i = 0; i < grids.length; i++) {
        if (heights.length < (i+1)) { heights.push([]); }
        const iconTextParagraphs = grids[i].querySelectorAll('.paragraph--type--icon-text-card .field-name-field-icon-graphic');

        for (let j = 0; j < iconTextParagraphs.length; j++) {
          let myHeight = iconTextParagraphs[j].getBoundingClientRect().height;
          if (heights[i].length < (j+1)) {
            heights[i].push({ height: myHeight, pass: false });
          }
          else if (myHeight == 0 || heights[i][j].height != myHeight) {
            heights[i][j].height = myHeight;
            heights[i][j].pass = false;
          }
          else {
            heights[i][j].pass = true;
          }
        }
      }

      // Check if all passed
      const failed = heights.filter(function(iconSet) {
        const failed = iconSet.filter(function(iconCard) {
          return !iconCard.pass;
        });
        return failed.length > 0;
      });

      if (failed.length == 0 && loadHeightAdjustment) {
        clearInterval(checks);
        loadHeightAdjustment();
      }
    }, 300);
  })(loadHeightAdjustment);
});